"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.present = void 0;
var ramda_1 = require("ramda");
/**
 * Проверяет что значение не является null или undefined
 */
function present(val) {
    return (0, ramda_1.complement)(ramda_1.isNil)(val);
}
exports.present = present;
//# sourceMappingURL=present.js.map